<template>
  <div class="warpper">
    <HeadNei :active="'Details'" />
    <div class="flex content">
      <div class="con-nav">
        <div
          :class="
            active == index ? 'nav_item active whole-bgt' : 'nav_item whole-bgt'
          "
          v-for="(item, index) in menuListData"
          :key="index"
          @click="handleMenuClick(index, item)"
        >
          <div class="nav-item-cont">
            <div class="nac_icon"></div>
            <p>{{ item.category }}</p>
          </div>
        </div>
      </div>
      <div class="con_box">
        <div class="con_tt whole-bgt">
          <span>{{ activeName || "--" }}</span>
        </div>
        <div class="con_bd" v-if="showBox">
          <div
            :class="
              artiveChang
                ? 'staActive con_time'
                : artiveInfo.content
                ? 'endActive con_time'
                : 'con_time'
            "
          >
            {{
              `时间：${(artiveInfo && artiveInfo.createdAt) ||
                `--`} | 来源：${(artiveInfo && artiveInfo.author) || "--"} `
            }}
          </div>
          <div class="con_flex">
            <p
              :class="
                artiveChang
                  ? 'staActive con_content'
                  : artiveInfo.content
                  ? 'endActive con_content'
                  : 'con_content'
              "
              v-html="artiveInfo && artiveInfo.content"
            ></p>
          </div>
        </div>
        <div class="con_bd" v-if="!showBox">
          <div class="con_contact">
            <el-table :data="contactData" stripe style="width: 100%">
              <el-table-column type="index" width="50"> </el-table-column>
              <el-table-column prop="professionalField" label="专业领域">
              </el-table-column>
              <el-table-column prop="businessScope" label="业务范围">
              </el-table-column>
              <el-table-column prop="contactPerson" label="联系人">
              </el-table-column>
              <el-table-column prop="phone" label="联系方式"> </el-table-column>
            </el-table>
            <div class="con_pag">
              <el-pagination
                background
                layout="prev, pager, next,total"
                hide-on-single-page
                :page-size="pageSize"
                :current-page="currentPage"
                :total="total"
                @current-change="handleCurrentChange"
              ></el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HeadNei from "@/components/HeadNei.vue";
export default {
  name: "Details",
  components: {
    HeadNei,
  },
  data() {
    return {
      menuListData: [],
      contactData: [],
      artiveInfo: {},
      activeName: "",
      artiveChang: false,
      showBox: true,
      active: 0,
      total: 0,
      pageSize: 10,
      currentPage: 1,
    };
  },
  methods: {
    async initMenuList() {
      const { result } = await this.$api.details.getCategoryList("3");
      result.push({
        category: "联系方式",
        id: 0,
      });
      this.menuListData = result;
      this.activeName = result[0].category;
      this.initArticleDetail(result[0].id);
    },
    handleMenuClick(key, value) {
      console.log("点击", key, value);
      this.artiveChang = true;
      this.active = key;
      this.activeName = value.category;
      if (key == 3) {
        this.showBox = false;
      } else {
        this.showBox = true;
        this.initArticleDetail(value.id);
      }
    },
    async initArticleDetail(id) {
      if (id !== 0) {
        let params = {
          categoryId: id,
        };
        const { result } = await this.$api.details.getArticleList(params);
        this.artiveInfo = result.records[0];
        console.log(result);
        this.artiveChang = false;
      } else {
        this.artiveInfo = {};
        this.artiveChang = false;
      }
    },
    async initContactList() {
      const { currentPage } = this;
      const { result } = await this.$api.details.getContactList({
        current: currentPage,
        size: 10,
      });
      this.currentPage = result.current;
      this.pageSize = result.size;
      this.total = result.total;
      this.contactData = result.records;
      console.log("result", result);
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.initContactList();
    },
  },
  mounted() {
    // 获取列表数据
    this.initMenuList();
    // 获取联系人数据
    this.initContactList();
  },
};
</script>
<style scoped>
.warpper {
  background: url(../assets/images/nei-bj.png), #091f36;
  min-height: 100vh;
}

.content {
  padding: 0 36px 36px;
}

.con-nav {
  width: 256px;
  margin: 0 34px 0 0;
}

.nav_item {
  width: 100%;
  height: 92px;
  background-image: url(../assets/images/nei-nav.png);
  padding: 29px 0 0 24px;
  cursor: pointer;
}

.nav_item .nav-item-cont {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
}

.nav_item p {
  font-size: 24px;
  font-weight: bold;
  color: #ffffff;
  transform: skewX(-10deg);
}

.nav_item .nac_icon {
  width: 28px;
  height: 30px;
  margin-right: 16px;
  background-image: url(../assets/images/ic1.png);
  background-size: cover;
}

.nav_item_b .nac_icon {
  background-image: url(../assets/images/ic2.png);
}

.nav_item_c .nac_icon {
  background-image: url(../assets/images/ic3.png);
}

.nav_item_d .nac_icon {
  background-image: url(../assets/images/ic4.png);
}

.nav_item.active,
.nav_item:hover {
  background-image: url(../assets/images/nei-nav-on.png);
}

.nav_item.active p,
.nav_item:hover p {
  background-image: -webkit-linear-gradient(bottom, #b9e4ff, #ffffff);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.nav_item.active .nac_icon,
.nav_item:hover .nac_icon {
  background-image: url(../assets/images/ic1_on.png);
}

.nav_item_b.active .nac_icon,
.nav_item_b:hover .nac_icon {
  background-image: url(../assets/images/ic2_on.png);
}

.nav_item_c.active .nac_icon,
.nav_item_c:hover .nac_icon {
  background-image: url(../assets/images/ic3_on.png);
}

.nav_item_d.active .nac_icon,
.nav_item_d:hover .nac_icon {
  background-image: url(../assets/images/ic4_on.png);
}

.con_box {
  flex: 1;
  margin-top: 30px;
}

.con_tt {
  background-image: url(../assets/images/deta-tt.png);
  width: 398px;
  height: 52px;
  font-size: 20px;
  font-weight: bold;
  line-height: 46px;
  padding-left: 70px;
}

.con_tt span {
  background-image: -webkit-linear-gradient(bottom, #b9e4ff, #ffffff);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.con_bd {
  background-color: rgba(7, 58, 94, 0.7);
  border: 1px solid #00bbe9;
  position: relative;
  padding: 56px 56px 28px 56px;
  color: #ffffff;
  font-size: 18px;
}

.con_bd::before,
.con_bd::after {
  content: "";
  width: 10px;
  height: 10px;
  background-image: url(../assets/images/san.png);
  background-size: cover;
  position: absolute;
  bottom: 2px;
  right: 2px;
}

.con_bd::after {
  right: auto;
  left: 2px;
  transform: rotateY(180deg);
}

.con_time {
  font-size: 16px;
  text-align: center;
  margin-bottom: 34px;
}

.con_flex {
  height: 680px;
  overflow-y: auto;
  filter: contrast(15);
}
.staActive {
  animation: staChange 0.5s normal ease;
}
@keyframes staChange {
  0% {
    filter: blur(0px);
    opacity: 1;
  }
  50% {
    filter: blur(40px);
    opacity: 0.5;
  }
  100% {
    filter: blur(80px);
    opacity: 0;
  }
}
.endActive {
  animation: endChange 0.5s normal ease;
}
@keyframes endChange {
  0% {
    filter: blur(80px);
    opacity: 0;
  }
  50% {
    filter: blur(40px);
    opacity: 0.5;
  }
  100% {
    filter: blur(0px);
    opacity: 1;
  }
  /* 0% {
		filter: blur(80px);
		opacity: 0;
	}
	25% {
		filter: blur(80px);
		opacity: 0.2;
	}
	50% {
		filter: blur(40px);
		opacity: 0.5;
	}
	80% {
		filter: blur(25px);
		opacity: 0.8;
	}
	100% {
		filter: blur(0px);
		opacity: 1;
	} */
}
.con_flex::-webkit-scrollbar-corner {
  background-color: #073a5e;
}

.con_flex::-webkit-scrollbar {
  width: 6px;
  height: 6px;
  border-radius: 3px;
}

.con_flex::-webkit-scrollbar-track {
  background: none;
}

.con_flex::-webkit-scrollbar-thumb {
  background-color: #073a5e;
  border-radius: 3px;
}

.con_flex p {
  line-height: 32px;
  text-indent: 36px;
}

.con_flex p + p {
  margin-top: 24px;
}

.con_contact {
  min-height: 605px;
  position: relative;
}
.con_pag {
  position: absolute;
  bottom: 0;
  right: 50%;
}
</style>
